import { render } from "./VehicleContainer.vue?vue&type=template&id=3920fe43"
import script from "./VehicleContainer.vue?vue&type=script&lang=js"
export * from "./VehicleContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__